<main class="main">
  <div class="main-wrapper">
    <section class="padding-first about1" id="about_us">
      <div class="container">

        <a [routerLink]="['/news']" [routerLinkActive]="['active']" class="more">
          <div class="icon-back">
            <span>Back</span>
          </div>
        </a>

        <div>
          <div class="bl-rows">
            <div class="text">
              <h2>Gennius XYZ Acquires Majority Stake in Utoppia to Expand Financial Infrastructure</h2>
              <span>By Gennius Feb 12, 2026</span>
            </div>
            <div class="img">
              <img src="./assets/img/gennius/bg-inside-notice-27.jpg" alt="">
            </div>
          </div>
        </div>

        <div class="bl-center">
            <p>Dubai / Miami / New York </p>
            <p>Gennius XYZ today announced the completion of its acquisition of a majority stake in Utoppia, a U.S.-based fintech
            platform providing access to U.S. bank accounts, card issuance and digital financial services under a regulated,
            compliance-first framework.</p>

            <p>The transaction grants Gennius XYZ controlling interest in Utoppia. It is not a full buyout. Utoppia will continue to
            operate as an independent company under its existing regulatory licenses, governance structure and investor base. The
            platform will operate under the brand ‘Utoppia by Gennius’.</p>

            <p>Utoppia operates in the United States, providing regulated USD banking, investment services and Visa card issuance.
            Through the integration, it will leverage Gennius’ global payments, rewards, tokenization and treasury capabilities
            while maintaining regulatory and operational independence.</p>

            <p>“Utoppia becomes a core pillar of our global money movement strategy. By combining regulated banking access with
            tokenized value, global payments, and rewards infrastructure, we are creating a platform where money, experiences, and
            digital assets move seamlessly and prepares both companies for the next chapter,” said <strong>Ruben Salazar Genovez, CEO of
            Gennius XYZ.</strong> “This critical investment reflects our disciplined approach to building platform scale, deeply integrated,
            strategically aligned, and focused on long-term ecosystem value rather than short-term expansion.”</p>

            <p>At the core of the integration is the digital representation and orchestration of user value across multiple financial
            rails. This structure enables users to interact with funds of good source including income, fiat balances, rewards or
            digital assets within a connected infrastructure supported by both Utoppia and Gennius’ technology.</p>

            <p>“Joining Gennius allows us to scale Utoppia far beyond what a standalone neobank could achieve. We retain our mission of
            expanding access to U.S. financial services while gaining global payments, rewards, and tokenization infrastructure,”
            said <strong>Stefano Angeli, Founder and CEO of Utoppia</strong>.</p>

            <p>Stefano Angeli will continue to lead Utoppia as CEO, maintaining independent responsibility for revenue operations,
            commercialization, regulatory compliance and licensing. Utoppia will remain focused on remote workers, freelancers,
            creators and digital entrepreneurs who require reliable access to U.S. dollar accounts worldwide. The platform enables
            users to receive payments, hold USD balances, spend globally via Visa debit cards, and manage cross-border transactions
            within a regulated framework.</p>

            <p>Operating independently, Utoppia provides USD bank accounts for nomads and gig-economy participants and plans to expand
            into international travel-related financial services. Its platform includes Pay & Get Paid functionality, crypto
            on/off-ramps, global card acceptance, and a unified rewards and benefits program.</p>

            <p>“From day one, Gennius XYZ was built to connect fragmented financial value into a single global ecosystem. Utoppia
            accelerates that vision by adding a strong regulated U.S. foundation combined with a digital-native customer base. This
            is not just an acquisition; it is a structural step toward building a borderless financial operating system,” said
            <strong>Sergio Arana, Founder of Gennius XYZ</strong>.</p>

            <p>This critical investment strengthens Gennius’ position as a global platform connecting payments, loyalty, tokenization
            and digital engagement, while preserving Utoppia’s independent operational model and regulatory standing.</p>

            <p><strong>About Gennius XYZ</strong></p>

            <p>Gennius builds infrastructure connecting payments, rewards, tokenization and digital experiences into a unified
            ecosystem, enabling financial institutions and consumer platforms to convert transactions into engagement and long-term
            value.</p>

            <p><strong>About Utoppia by Gennius</strong></p>

            <p>Utoppia by Gennius provides regulated access to U.S. financial services combined with global payments, tokenized value,
            rewards and marketplace infrastructure, enabling users to earn, hold and spend value across borders while operating
            independently under its existing regulatory framework.</p>


        </div>

      </div>
    </section>

  </div>
</main>
<app-footer></app-footer>
